import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';

function FeatureProducts() {
    const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='mb-4'>
      <Container>
        <Row>
          <Col md={4}>
          <div className='d-flex flex-column justify-content-center align-items-center rounded border py-3 mb-3'>
            <div style={{height: "55px",width: "55px",background:"#2D103A"}}className='rounded-circle d-flex justify-content-center align-items-center mb-3'>
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="white" class="bi bi-cart" viewBox="0 0 16 16">
  <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
</svg>
            </div>

<h3>{currentLocal.home.Fastshipping}</h3>       
     <p>{currentLocal.home.Delivery}</p>
          </div>
          </Col>
      <Col md={4}>
          <div className='d-flex flex-column justify-content-center align-items-center rounded border py-3 mb-3'>
            <div style={{height: "55px",width: "55px",background:"#2D103A"}}className='rounded-circle d-flex justify-content-center align-items-center mb-3'>
<svg viewBox="0 0 24 24" fill="none"width={34}>
                           <path d="M12 1L3 5V11C3 16 6 20.5 12 23C18 20.5 21 16 21 11V5L12 1Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                           <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                       </svg>
            </div>

<h3>{currentLocal.home.guaranteeback}</h3>       
     <p>{currentLocal.home.guarantee}</p>
          </div>
          </Col>
      <Col md={4}>
          <div className='d-flex flex-column justify-content-center align-items-center rounded border py-3 mb-3'>
            <div style={{height: "55px",width: "55px",background:"#2D103A"}}className='rounded-circle d-flex justify-content-center align-items-center mb-3'>
<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="white" class="bi bi-patch-check" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
  <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911z"/>
</svg>
            </div>

<h3>{currentLocal.home.Licensed}</h3>       
     <p>{currentLocal.home.Authority}</p>
          </div>
          </Col>
                  </Row>
      </Container>
    </div>
  )
}

export default FeatureProducts